export const getInvitados = (hash) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");
   // myHeaders.append("Authorization", `Bearer ${localStorage.getItem("Bodacys")}`)

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`https://api-eventos.solucioneskmp.com/Eventos/invitados/${hash}`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}

// export const getInvitados = (idP) => {
//   return new Promise((resolve, reject) => {
//     const myHeaders = new Headers();
//     var formdata = new FormData();
//     myHeaders.append("Authorization", `Bearer ${localStorage.getItem("Bodacys")}`)
//     formdata.append("id", idP);
//     var requestOptions = {
//       method: 'POST',
//       headers: myHeaders,
//       body: formdata,
//       redirect: 'follow'
//     };

//     fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/Pagos`, requestOptions)
//       .then(response => response.json())
//       .then(result => resolve(result))
//       .catch(error => reject(error));
//   })
// }